import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api, getUserClaims, getUserMessages, adminDeleteUser, adminDeleteImage, adminRemoveCreatorFromBrowse, getUserConnections, sendSmsToUser, getSecureVideoUrl, getSecureDeletedImageUrl, getUserRatings, getUserAuctions } from '../api';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import SmsIcon from '@mui/icons-material/Sms';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BadgeIcon from '@mui/icons-material/Badge';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import FaceIcon from '@mui/icons-material/Face';
import CakeIcon from '@mui/icons-material/Cake';
import CardHeader from '@mui/material/CardHeader';
import CircularProgress from '@mui/material/CircularProgress';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import StarIcon from '@mui/icons-material/Star';
import GavelIcon from '@mui/icons-material/Gavel';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import VideocamIcon from '@mui/icons-material/Videocam';
import RateReviewIcon from '@mui/icons-material/RateReview';
import StorefrontIcon from '@mui/icons-material/Storefront';
import Rating from '@mui/material/Rating';
import TagIcon from '@mui/icons-material/Tag';
import GroupIcon from '@mui/icons-material/Group';
import HistoryIcon from '@mui/icons-material/History';
import LoginIcon from '@mui/icons-material/Login';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import dayjs from 'dayjs';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { alpha, useTheme } from '@mui/material/styles';
import PageHeader from './common/PageHeader';
import EmptyState from './common/EmptyState';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import InputAdornment from '@mui/material/InputAdornment';
import SendIcon from '@mui/icons-material/Send';
import Tooltip from '@mui/material/Tooltip';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import ChatIcon from '@mui/icons-material/Chat';
import ConversationModal from './ConversationModal';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const CONNECTION_CHIP = {
  instant_connect: { icon: <FlashOnIcon />, label: 'Instant Connect', color: 'info' },
  bid_to_connect: { icon: <GavelIcon />, label: 'Bid to Connect', color: 'secondary' },
  video_call: { icon: <VideocamIcon />, label: 'Video call', color: 'success' },
};

export default function UserDetail () {
const theme = useTheme();
const { id } = useParams();
const location = useLocation();
const navigate = useNavigate();
const [data, setData] = useState(null);
const [transactions, setTransactions] = useState([]);
const [profileImageUrls, setProfileImageUrls] = useState([]);
const [imageLoading, setImageLoading] = useState(false);
const [claimInfo, setClaimInfo] = useState({ total: 0, currentStreak: 0, longestStreak: 0, claims: [] });
const [claimsOpen, setClaimsOpen] = useState(false);
const [messages, setMessages] = useState([]);
const [msgMeta, setMsgMeta] = useState(null);
const [msgLoading, setMsgLoading] = useState(true);
const [hasMoreMessages, setHasMoreMessages] = useState(false);
const [isLoadingMore, setIsLoadingMore] = useState(false);
const [messagesOffset, setMessagesOffset] = useState(0);
const messagesContainerRef = React.useRef(null);
const [autoScrollBottom, setAutoScrollBottom] = useState(false);
const [deleteOpen, setDeleteOpen] = useState(false);
const [deleteTyped, setDeleteTyped] = useState('');
const [deleteBusy, setDeleteBusy] = useState(false);
const [deleteResult, setDeleteResult] = useState(null);
const [connections, setConnections] = useState([]);
const [connectionsMeta, setConnectionsMeta] = useState(null);
const [connectionsLoading, setConnectionsLoading] = useState(true);
const [connectionsError, setConnectionsError] = useState('');
const [newMsg, setNewMsg] = useState('');
const [sending, setSending] = useState(false);
const [toast, setToast] = useState(null);
const [videoUrl, setVideoUrl] = useState(null);
const [videoLoading, setVideoLoading] = useState(false);
const [videoModalOpen, setVideoModalOpen] = useState(false);
const [selectedImageIndex, setSelectedImageIndex] = useState(null);
const [chatOpen, setChatOpen] = useState(false);
const [chatPair, setChatPair] = useState(null);
const [deletedImageUrls, setDeletedImageUrls] = useState([]);
const [deletedImageLoading, setDeletedImageLoading] = useState(false);
const [selectedDeletedImageIndex, setSelectedDeletedImageIndex] = useState(null);
const [ratings, setRatings] = useState([]);
const [ratingsLoading, setRatingsLoading] = useState(true);
const [ratingsOpen, setRatingsOpen] = useState(false);
const [auctions, setAuctions] = useState([]);
const [auctionsLoading, setAuctionsLoading] = useState(true);
const [profileImageMeta, setProfileImageMeta] = useState([]);
const [deleteImageOpen, setDeleteImageOpen] = useState(false);
const [deleteImageId, setDeleteImageId] = useState(null);
const [deleteImageBusy, setDeleteImageBusy] = useState(false);
const [deleteImagePermanent, setDeleteImagePermanent] = useState(false);
const [removeCreatorOpen, setRemoveCreatorOpen] = useState(false);
const [removeCreatorBusy, setRemoveCreatorBusy] = useState(false);

useEffect(() => { 
  // Fetch the user data
  api.get(`/users/${id}`).then(r => {
    setData(r.data);

    // Handle profile images loading (up to 3)
    if (r.data.profileImages && r.data.profileImages.length > 0) {
      setProfileImageMeta(r.data.profileImages);
      setImageLoading(true);

      api.get(`/secure-image-url/${id}`)
        .then(response => {
          if (response.data && response.data.urls) {
            setProfileImageUrls(response.data.urls);
          }
          setImageLoading(false);
        })
        .catch(error => {
          console.error('Error fetching secure image URLs:', error);
          setImageLoading(false);
        });
    } else {
      setProfileImageMeta([]);
      setProfileImageUrls([]);
    }
  })
  .catch(error => {
    console.error("Error fetching user data:", error);
  });

  // Fetch transaction data
  api.get(`/users/${id}/transactions`).then(r => {
    setTransactions(r.data);
  }).catch(err => {
    console.error('Error fetching transactions:', err);
  });

  // Fetch verification video URL
  const loadVideo = async () => {
    try {
      setVideoLoading(true);
      const videoData = await getSecureVideoUrl(id);
      if (videoData && videoData.url) {
        setVideoUrl(videoData.url);
      }
    } catch (error) {
      console.error('Error fetching verification video:', error);
    } finally {
      setVideoLoading(false);
    }
  };
  loadVideo();

  // Fetch deleted images
  const loadDeletedImages = async () => {
    try {
      setDeletedImageLoading(true);
      const deletedData = await getSecureDeletedImageUrl(id);
      if (deletedData && deletedData.urls) {
        setDeletedImageUrls(deletedData.urls);
      }
    } catch (error) {
      console.error('Error fetching deleted images:', error);
    } finally {
      setDeletedImageLoading(false);
    }
  };
  loadDeletedImages();
}, [id]);

useEffect(() => {
  const loadClaims = async () => {
    try {
      const res = await getUserClaims(id);
      setClaimInfo(res || { total:0, currentStreak:0, longestStreak:0, claims:[] });
    } catch(e) {
      console.error('Failed to load user claims', e);
    }
  };
  loadClaims();
}, [id]);

useEffect(() => {
  const loadConnections = async () => {
    try {
      setConnectionsLoading(true);
      const res = await getUserConnections(id, { limit: 200 });
      setConnections(res?.data || []);
      setConnectionsMeta({ start: res?.start, end: res?.end });
      setConnectionsError('');
    } catch (e) {
      setConnections([]);
      setConnectionsError('Failed to load connections');
    } finally {
      setConnectionsLoading(false);
    }
  };
  loadConnections();
}, [id]);

useEffect(() => {
  const loadRatings = async () => {
    try {
      setRatingsLoading(true);
      const res = await getUserRatings(id);
      setRatings(res || []);
    } catch (e) {
      setRatings([]);
    } finally {
      setRatingsLoading(false);
    }
  };
  loadRatings();
}, [id]);

useEffect(() => {
  const loadAuctions = async () => {
    try {
      setAuctionsLoading(true);
      const res = await getUserAuctions(id);
      setAuctions(res || []);
    } catch (e) {
      setAuctions([]);
    } finally {
      setAuctionsLoading(false);
    }
  };
  loadAuctions();
}, [id]);

useEffect(() => {
  const loadMessages = async () => {
    try {
      setMsgLoading(true);
      const res = await getUserMessages(id, {
        startDate: dayjs().subtract(90, 'day').format('YYYY-MM-DD'),
        endDate: dayjs().format('YYYY-MM-DD'),
        limit: 20,
        offset: 0,
        order: 'desc'
      });
      const fetchedMessages = res.messages || [];
      // Reverse to display chronologically (oldest to newest, with newest at bottom)
      setMessages(fetchedMessages.reverse());
      setMsgMeta(res.meta || null);
      setMessagesOffset(fetchedMessages.length);
      // If we got exactly 20 messages, there might be more
      setHasMoreMessages(fetchedMessages.length === 20);
      setAutoScrollBottom(true);
    } catch (e) {
      console.error('Failed to load user messages', e);
    } finally {
      setMsgLoading(false);
    }
  };
  loadMessages();
}, [id]);

// Auto-scroll to bottom after initial messages load or explicit reloads only
useEffect(() => {
  if (!msgLoading && autoScrollBottom && messages.length > 0 && messagesContainerRef.current) {
    messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
    setAutoScrollBottom(false);
  }
}, [msgLoading, messages.length, autoScrollBottom]);

// Helper to load more (older) messages when scrolling to top
const loadMoreMessages = async () => {
  if (isLoadingMore || !hasMoreMessages) return;
  
  try {
    setIsLoadingMore(true);
    const container = messagesContainerRef.current;
    const previousScrollHeight = container?.scrollHeight || 0;
    
    const res = await getUserMessages(id, {
      startDate: dayjs().subtract(90, 'day').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
      limit: 20,
      offset: messagesOffset,
      order: 'desc'
    });
    
    const olderMessages = res.messages || [];
    if (olderMessages.length > 0) {
      // Prepend older messages to the beginning
      setMessages(prev => [...olderMessages, ...prev]);
      setMessagesOffset(prev => prev + olderMessages.length);
      setHasMoreMessages(olderMessages.length === 20);
      
      // Restore scroll position after new messages are added
      setTimeout(() => {
        if (container) {
          const newScrollHeight = container.scrollHeight;
          container.scrollTop = newScrollHeight - previousScrollHeight;
        }
      }, 0);
    } else {
      setHasMoreMessages(false);
    }
  } catch (e) {
    console.error('Failed to load more messages', e);
  } finally {
    setIsLoadingMore(false);
  }
};

// Helper to reload messages after sending
const reloadMessages = async () => {
  try {
    setMsgLoading(true);
    const res = await getUserMessages(id, {
      startDate: dayjs().subtract(90, 'day').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
      limit: 20,
      offset: 0
    });
    const fetchedMessages = (res.messages || []).reverse();
    setMessages(fetchedMessages);
    setMsgMeta(res.meta || null);
    setMessagesOffset(fetchedMessages.length);
    setHasMoreMessages(fetchedMessages.length === 20);
  } finally {
    setMsgLoading(false);
    // Scroll to bottom after reload
    setAutoScrollBottom(true);
  }
};

// Handle scroll to detect when user reaches the top
const handleScroll = () => {
  const container = messagesContainerRef.current;
  if (!container) return;
  
  // Check if scrolled near the top (within 50px threshold)
  if (container.scrollTop < 50 && hasMoreMessages && !isLoadingMore) {
    loadMoreMessages();
  }
};

// Format date in a readable way
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
};

// Calculate age from birth_date
const calculateAge = (birthDate) => {
  if (!birthDate) return null;
  try {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  } catch (e) {
    console.error("Error calculating age:", e);
    return null;
  }
};

// Format full date and time
const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
};

// Handle viewing conversation with a connection
const handleViewConversation = (connection) => {
  // Determine roles based on the connection role
  // If the current user's role is 'bidder', they are the bidder
  // If the current user's role is 'recipient', they are the recipient
  const userRole = connection.role === 'bidder' ? 'bidder' : 'recipient';
  const partnerRole = connection.role === 'bidder' ? 'recipient' : 'bidder';
  
  setChatPair({
    userId: id, // current user ID from params
    partnerId: connection.partnerId,
    userName: user?.username || `User #${id}`,
    partnerName: connection.partnerUsername || `User #${connection.partnerId}`,
    userRole: userRole,
    partnerRole: partnerRole
  });
  setChatOpen(true);
};

// Refresh all user data (after image delete or remove creator)
const refreshUserData = () => {
  api.get(`/users/${id}`).then(r => {
    setData(r.data);
    if (r.data.profileImages && r.data.profileImages.length > 0) {
      setProfileImageMeta(r.data.profileImages);
      setImageLoading(true);
      api.get(`/secure-image-url/${id}`)
        .then(response => {
          if (response.data && response.data.urls) {
            setProfileImageUrls(response.data.urls);
          }
          setImageLoading(false);
        })
        .catch(() => setImageLoading(false));
    } else {
      setProfileImageMeta([]);
      setProfileImageUrls([]);
    }
  }).catch(err => console.error('Error refreshing user data:', err));
};

const handleDeleteImage = async () => {
  if (!deleteImageId) return;
  setDeleteImageBusy(true);
  try {
    const result = await adminDeleteImage(deleteImageId, { permanentDelete: deleteImagePermanent });
    setToast({ sev: 'success', msg: result.message || 'Image deleted successfully' });
    setDeleteImageOpen(false);
    setDeleteImageId(null);
    setDeleteImagePermanent(false);
    setSelectedImageIndex(null);
    refreshUserData();
  } catch (err) {
    const msg = err.response?.data?.message || 'Failed to delete image';
    setToast({ sev: 'error', msg });
  } finally {
    setDeleteImageBusy(false);
  }
};

const handleRemoveCreator = async () => {
  setRemoveCreatorBusy(true);
  try {
    const result = await adminRemoveCreatorFromBrowse(id);
    const details = result.data;
    let msg = result.message || 'Creator removed from browse';
    if (details?.auctions_removed > 0) {
      msg += ` (${details.auctions_removed} auction(s) cleaned up)`;
    }
    setToast({ sev: 'success', msg });
    setRemoveCreatorOpen(false);
    refreshUserData();
  } catch (err) {
    const msg = err.response?.data?.message || 'Failed to remove creator from browse';
    setToast({ sev: 'error', msg });
  } finally {
    setRemoveCreatorBusy(false);
  }
};

if (!data) return (
  <Paper sx={{ p: 3, textAlign: 'center' }}>
    <Typography>Loading...</Typography>
  </Paper>
);

const { user, tokenStats, directReferrals, loginHistory, socialMediaHandles, niches, instantConnectPreset, bidToConnectPreset } = data;
// Calculate age based on Birth_date field
const age = user.birthDate ? calculateAge(user.birthDate) : null;
const isCreator = Number(user.isCreator) === 1;

// Extract city and state from location
const city = user.city;
const state = user.state;
const locationLine = [city, state, user.postalCode].filter(Boolean).join(', ');

return (
<>
  {(() => {
    const knownRoutes = [
      { key: 'leaderboard',   label: 'Leaderboard',   match: (p) => p.startsWith('/leaderboard'),   path: '/leaderboard' },
      { key: 'user-report',   label: 'User Report',   match: (p) => p.startsWith('/user-report'),   path: '/user-report' },
      { key: 'user-activity', label: 'User Activity', match: (p) => p.startsWith('/user-activity'), path: '/user-activity' },

      { key: 'sms-reporting', label: 'SMS Reporting', match: (p) => p.startsWith('/sms-reporting'), path: '/sms-reporting' },
      { key: 'referral-tree', label: 'Referral Tree', match: (p) => p.startsWith('/referral-tree'), path: null },
    ];
    const lastRoute = localStorage.getItem('lastRoute') || '';
    let from = location.state?.from || null;
    if (!from && lastRoute && !lastRoute.startsWith(`/user/`)) {
      const match = knownRoutes.find(r => r.match(lastRoute));
      if (match) {
        from = {
          label: match.label,
          path: match.key === 'referral-tree' ? lastRoute : match.path || lastRoute
        };
      }
    }
    const backLabel = from?.label ? `Back to ${from.label}` : 'Back';
    const backPath  = from?.path || '/user-report';
    const handleBack = () => {
      if (window.history.length > 1) navigate(-1);
      else navigate(backPath, { replace: true });
    };

    return (
      <PageHeader
        title={user?.username || 'User Detail'}
        subtitle={
          <span>
            <Link to="/">Home</Link>
            {from ? <> / <Link to={from.path}>{from.label}</Link></> : <> / Users</>}
            {' / '}
            {user?.username || user?.id}
          </span>
        }
        actions={
          <Box sx={{ display:'flex', gap:1 }}>
            <Button onClick={handleBack} variant="outlined" size="small">
              {backLabel}
            </Button>
            {isCreator && (
              <Button
                variant="contained"
                color="warning"
                size="small"
                onClick={() => setRemoveCreatorOpen(true)}
              >
                Remove from Browse
              </Button>
            )}
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={() => { setDeleteOpen(true); setDeleteTyped(''); setDeleteResult(null); }}
            >
              Delete user
            </Button>
          </Box>
        }
      />
    );
  })()}
  <Grid container spacing={3} sx={{ mt: 1 }}>
  <Grid item xs={12} md={4}>
    <Card 
      elevation={3} 
      sx={{ position: 'relative', borderRadius: 2 }}
    >
      {/* Hero header */}
      <Box sx={{ position: 'relative' }}>
        {/* Gradient bar */}
        <Box
          sx={{
            height: 140,
            background:
              `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.primary.main} 100%)`,
            borderTopLeftRadius: 2,
            borderTopRightRadius: 2
          }}
        />

        {/* Profile Images - up to 3 displayed horizontally */}
        <Box
          sx={{
            position: 'absolute',
            left: '50%',
            bottom: -60,
            transform: 'translateX(-50%)',
            display: 'flex',
            gap: 2,
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          {profileImageUrls.length > 0 ? (
            profileImageUrls.map((url, index) => (
              <Box key={index} sx={{ position: 'relative' }}>
                <Avatar
                  src={url}
                  alt={`${user.username || 'User'} profile ${index + 1}`}
                  variant="square"
                  onClick={() => setSelectedImageIndex(index)}
                  sx={{
                    width: 120,
                    height: 120,
                    border: '4px solid white',
                    boxShadow: 3,
                    bgcolor: 'primary.main',
                    borderRadius: 2,
                    cursor: 'pointer',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    '&:hover': {
                      transform: 'scale(1.05)',
                      boxShadow: 5
                    }
                  }}
                />
                {profileImageMeta[index]?.id && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDeleteImageId(profileImageMeta[index].id);
                      setDeleteImageOpen(true);
                    }}
                    sx={{
                      position: 'absolute',
                      top: -6,
                      right: -6,
                      bgcolor: 'error.main',
                      color: 'white',
                      width: 22,
                      height: 22,
                      '&:hover': { bgcolor: 'error.dark' },
                    }}
                  >
                    <CloseIcon sx={{ fontSize: 14 }} />
                  </IconButton>
                )}
              </Box>
            ))
          ) : (
            <Avatar
              alt={user.username || 'User profile'}
              variant="square"
              sx={{
                width: 120,
                height: 120,
                border: '4px solid white',
                boxShadow: 3,
                bgcolor: 'primary.main',
                borderRadius: 2
              }}
            >
              {(user.username || 'U').charAt(0).toUpperCase()}
            </Avatar>
          )}
        </Box>
      </Box>

      {/* Body */}
      <CardContent
        sx={{
          pt: 8,       // 8 * 8 px = 64 px → clears the avatars (120px - 60px overlap)
          pb: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {/* ── Name & age ─────────────────────────────── */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
            {user.username || 'Unnamed User'}
          </Typography>
        </Box>
        
        {age && (
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ mb: 2 }}
          >
            {age} years&nbsp;old
          </Typography>
        )}
        
        {/* ── Creator/Fan + status chips ─────────────── */}
        <Box sx={{ mb: 3, display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          {user.completed && (
            <Chip
              color="success"
              icon={<CheckCircleIcon />}
              label="Verified"
              size="small"
            />
          )}

          {isCreator ? (
            <>
              <Chip
                icon={<StorefrontIcon />}
                label="Creator"
                size="small"
                sx={{ bgcolor: theme.palette.secondary.main, color: 'white', '& .MuiChip-icon': { color: 'white' } }}
              />
              <Chip
                size="small"
                label={Number(user.isApprovedCreator) === 1 ? 'Approved' : 'Pending'}
                color={Number(user.isApprovedCreator) === 1 ? 'success' : 'warning'}
                variant="outlined"
              />
            </>
          ) : (
            <Chip
              icon={<PersonIcon />}
              label="Fan"
              size="small"
              color="info"
              variant="outlined"
            />
          )}

          {user.gender && (
            <Chip label={user.gender} variant="outlined" size="small" />
          )}
        </Box>
        
        {/* --- Bidsy Tokens panel --- */}
        <Box
          sx={{
            width: '100%',
            mb: 2,
            p: 2,
            borderRadius: 2,
            background: `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.primary.main} 100%)`,
            color: 'common.white',
            boxShadow: 3,
          }}
          aria-label="Bidsy token balances"
        >
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', width: 32, height: 32, mr: 1.25 }}>
              <MonetizationOnIcon fontSize="small" />
            </Avatar>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Bidsy Tokens</Typography>
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
            <Box sx={{ p: 1.25, borderRadius: 1, bgcolor: 'rgba(255,255,255,0.1)' }}>
              <Typography variant="caption" sx={{ opacity: 0.85 }}>Total Balance</Typography>
              <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1 }}>
                {(data?.tokenBalance?.balance ?? 0).toLocaleString()}
              </Typography>
            </Box>
            <Box sx={{ p: 1.25, borderRadius: 1, bgcolor: 'rgba(255,255,255,0.1)' }}>
              <Typography variant="caption" sx={{ opacity: 0.85 }}>Redeemable</Typography>
              <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1 }}>
                {(data?.tokenBalance?.redeemable ?? 0).toLocaleString()}
              </Typography>
            </Box>
          </Box>
        </Box>
        
        <Box sx={{ width: '100%', mt: 1 }}>
          <List dense sx={{ width: '100%' }}>
            {user.phoneNumber && (
              <ListItem>
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  <PhoneIcon fontSize="small" color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Phone" 
                  secondary={user.phoneNumber}
                  primaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                  secondaryTypographyProps={{ variant: 'body2', fontWeight: 'medium' }}
                />
              </ListItem>
            )}
            
            {user.email && (
              <ListItem>
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  <EmailIcon fontSize="small" color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Email"
                  secondary={user.email}
                  primaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                  secondaryTypographyProps={{ variant: 'body2', fontWeight: 'medium' }}
                />
              </ListItem>
            )}

            {locationLine && (
              <ListItem>
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  <LocationOnIcon fontSize="small" color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Location" 
                  secondary={locationLine}
                  primaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                  secondaryTypographyProps={{ variant: 'body2', fontWeight: 'medium' }}
                />
              </ListItem>
            )}
            {/* Referred by */}
            {typeof user.referredBy !== 'undefined' && (
              <ListItem>
                <ListItemIcon sx={{ minWidth: '40px' }}>
                  <BadgeIcon fontSize="small" color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Referred by"
                  secondary={
                    user.referredBy
                      ? (
                          <Link
                            to={`/user/${user.referredBy}`}
                            state={{ from: { label: user.username || `User #${user.id}`, path: `/user/${user.id}` } }}
                          >
                            {user.referredByUsername || `User #${user.referredBy}`}
                          </Link>
                        )
                      : 'Organic signup'
                  }
                  primaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                  secondaryTypographyProps={{ variant: 'body2', fontWeight: 'medium' }}
                />
              </ListItem>
            )}
          </List>
        </Box>
        
        {/* Verification Video Button */}
        {videoUrl && (
          <Box sx={{ width: '100%', mt: 2 }}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<VideoLibraryIcon />}
              onClick={() => setVideoModalOpen(true)}
              sx={{
                borderColor: 'primary.main',
                color: 'primary.main',
                '&:hover': {
                  borderColor: 'primary.dark',
                  bgcolor: alpha(theme.palette.primary.main, 0.04)
                }
              }}
            >
              View Verification Video
            </Button>
          </Box>
        )}
        
        {/* View Deleted Images Button */}
        {deletedImageUrls.length > 0 && (
          <Box sx={{ width: '100%', mt: 2 }}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={<ImageIcon />}
              onClick={() => setSelectedDeletedImageIndex(0)}
              sx={{
                borderColor: 'error.main',
                color: 'error.main',
                '&:hover': {
                  borderColor: 'error.dark',
                  bgcolor: alpha('#f44336', 0.04)
                }
              }}
            >
              View Deleted Images ({deletedImageUrls.length})
            </Button>
          </Box>
        )}
        
        {user.shortBio && (
          <Box sx={{ width: '100%', mt: 1 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Bio
            </Typography>
            <Typography variant="body2" paragraph sx={{ 
              px: 2, 
              py: 1.5, 
              bgcolor: alpha('#f5f5f5', 0.5), 
              borderRadius: 1,
              fontStyle: 'italic'
            }}>
              {user.shortBio}
            </Typography>
          </Box>
        )}
        
        {/* Social Media Handles (creator only) */}
        {isCreator && socialMediaHandles && socialMediaHandles.length > 0 && (
          <Box sx={{ width: '100%', mt: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              Social Media Handles
            </Typography>
            <List dense>
              {socialMediaHandles.map((h, idx) => (
                <ListItem key={idx} disableGutters sx={{ pb: 0.5 }}>
                  <ListItemText
                    primary={h.type}
                    secondary={h.handle}
                    primaryTypographyProps={{ fontWeight: 'bold', variant: 'body2' }}
                    secondaryTypographyProps={{ variant: 'body2' }}
                  />
                  <Chip
                    size="small"
                    label={Number(h.isApproved) === 1 ? 'Approved' : 'Pending'}
                    color={Number(h.isApproved) === 1 ? 'success' : 'warning'}
                    variant="outlined"
                    sx={{ ml: 1 }}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        )}

        {/* Niches (creator only) */}
        {isCreator && niches && niches.length > 0 && (
          <Box sx={{ width: '100%', mt: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <TagIcon fontSize="small" /> Niches
            </Typography>
            <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
              {niches.map((n, idx) => (
                <Chip
                  key={idx}
                  label={n.name}
                  size="small"
                  variant={Number(n.isPrimary) === 1 ? 'filled' : 'outlined'}
                  color={Number(n.isPrimary) === 1 ? 'primary' : 'default'}
                />
              ))}
            </Box>
          </Box>
        )}
        
        <Typography variant="body2" color="text.secondary" sx={{ mt: 3, opacity: 0.7 }}>
          User ID: {user.id} &nbsp;|&nbsp; Joined:&nbsp;{formatDate(user.createdAt || user.Created_at)} &nbsp;|&nbsp; Onboarded: {typeof user.onboarded === 'number' ? user.onboarded : (user.onboarded ?? '—')}
        </Typography>
      </CardContent>
    </Card>
  </Grid>

  <Grid item xs={12} md={8}>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

      {/* Auction Configuration (creator only) */}
      {isCreator && (
        <Card elevation={3} sx={{ borderRadius: 2 }}>
          <CardHeader
            avatar={<Avatar sx={{ bgcolor: theme.palette.secondary.main }}><StorefrontIcon /></Avatar>}
            title="Auction Configuration"
          />
          <Divider />
          <CardContent>
            <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
              <Box>
                <Typography variant="caption" color="text.secondary">Instant Connect Price</Typography>
                <Typography variant="body1" fontWeight="bold">{user.instantConnectPrice != null ? Number(user.instantConnectPrice).toLocaleString() : '—'}</Typography>
              </Box>
              <Box>
                <Typography variant="caption" color="text.secondary">IC Status</Typography>
                <Box><Chip size="small" label={user.instantConnectStatus || 'N/A'} color={user.instantConnectStatus === 'active' ? 'success' : 'default'} /></Box>
              </Box>
              <Box>
                <Typography variant="caption" color="text.secondary">Minimum Bid (BTC)</Typography>
                <Typography variant="body1" fontWeight="bold">{user.minimumBid != null ? Number(user.minimumBid).toLocaleString() : '—'}</Typography>
              </Box>
              <Box>
                <Typography variant="caption" color="text.secondary">BTC Status</Typography>
                <Box><Chip size="small" label={user.bidToConnectStatus || 'N/A'} color={user.bidToConnectStatus === 'active' ? 'success' : 'default'} /></Box>
              </Box>
              <Box>
                <Typography variant="caption" color="text.secondary">Available for Bids</Typography>
                <Box><Chip size="small" label={Number(user.availableForBids) === 1 ? 'Yes' : 'No'} color={Number(user.availableForBids) === 1 ? 'success' : 'default'} variant="outlined" /></Box>
              </Box>
              <Box>
                <Typography variant="caption" color="text.secondary">Email Notifications</Typography>
                <Box><Chip size="small" label={Number(user.emailNotification) === 1 ? 'On' : 'Off'} color={Number(user.emailNotification) === 1 ? 'primary' : 'default'} variant="outlined" /></Box>
              </Box>
            </Box>

            {(instantConnectPreset || bidToConnectPreset) && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>Connection Presets</Typography>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  {instantConnectPreset && (
                    <Chip
                      icon={<FlashOnIcon />}
                      label={`IC: ${instantConnectPreset.label || instantConnectPreset.type} ${instantConnectPreset.type === 'video' ? `(${instantConnectPreset.videoDurationMinutes} min)` : `(${instantConnectPreset.textDays} days)`}`}
                      variant="outlined"
                      size="small"
                    />
                  )}
                  {bidToConnectPreset && (
                    <Chip
                      icon={<GavelIcon />}
                      label={`BTC: ${bidToConnectPreset.label || bidToConnectPreset.type} ${bidToConnectPreset.type === 'video' ? `(${bidToConnectPreset.videoDurationMinutes} min)` : `(${bidToConnectPreset.textDays} days)`}`}
                      variant="outlined"
                      size="small"
                    />
                  )}
                </Box>
              </Box>
            )}

            {(user.instantConnectConnectionExpectations || user.bidToConnectConnectionExpectations) && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>Connection Expectations</Typography>
                {user.instantConnectConnectionExpectations && (
                  <Typography variant="body2" sx={{ mb: 0.5 }}><b>IC:</b> {user.instantConnectConnectionExpectations}</Typography>
                )}
                {user.bidToConnectConnectionExpectations && (
                  <Typography variant="body2"><b>BTC:</b> {user.bidToConnectConnectionExpectations}</Typography>
                )}
              </Box>
            )}
          </CardContent>
        </Card>
      )}

      {/* Connections */}
      <Card elevation={3} sx={{ borderRadius: 2 }}>
        <CardHeader
          avatar={<Avatar sx={{ bgcolor: 'primary.main' }}><GroupIcon /></Avatar>}
          title="Connections"
          subheader={
            connectionsMeta ? `Window: ${String(connectionsMeta.start || '').slice(0,10)} → ${String(connectionsMeta.end || '').slice(0,10)}` : ''
          }
        />
        <Divider />
        <CardContent>
          {connectionsLoading ? (
            <Box sx={{ display:'flex', justifyContent:'center', py: 4 }}><CircularProgress /></Box>
          ) : connectionsError ? (
            <Alert severity="error">{connectionsError}</Alert>
          ) : !connections.length ? (
            <Typography variant="body2" color="text.secondary">No connections found.</Typography>
          ) : (
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight:'bold' }}>Connected with</TableCell>
                  <TableCell sx={{ fontWeight:'bold' }}>Type</TableCell>
                  <TableCell sx={{ fontWeight:'bold' }}>Preset</TableCell>
                  <TableCell sx={{ fontWeight:'bold' }}>Role</TableCell>
                  <TableCell sx={{ fontWeight:'bold' }} align="right">Bid amount</TableCell>
                  <TableCell sx={{ fontWeight:'bold' }}>Status</TableCell>
                  <TableCell sx={{ fontWeight:'bold' }}>When</TableCell>
                  <TableCell sx={{ fontWeight:'bold' }} align="center">Chat</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {connections.map((c, i) => (
                  <TableRow key={`${c.partnerId || 'null'}-${i}`} sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}>
                    <TableCell>
                      {c.partnerId ? (
                        <Link
                          to={`/user/${c.partnerId}`}
                          state={{ from: { label: user.username || `User #${user.id}`, path: `/user/${user.id}` } }}
                          style={{ textDecoration:'none', color: theme.palette.primary.main, fontWeight:600 }}
                        >
                          {c.partnerUsername || `User #${c.partnerId}`}
                        </Link>
                      ) : (c.partnerUsername || '(unknown)')}
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        {...(CONNECTION_CHIP[c.connectionType] || CONNECTION_CHIP.bid_to_connect)}
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>
                      {c.presetLabel
                        ? `${c.presetLabel} ${c.presetType === 'video' ? `(${c.presetVideoDuration} min)` : c.presetType === 'text' ? `(${c.presetTextDays} days)` : ''}`
                        : '—'}
                    </TableCell>
                    <TableCell sx={{ textTransform:'capitalize' }}>{c.role}</TableCell>
                    <TableCell align="right">{c.amount !== null && c.amount !== undefined ? Number(c.amount).toLocaleString() : '—'}</TableCell>
                    <TableCell>{c.status || '—'}</TableCell>
                    <TableCell>{formatDateTime(c.connectedAt)}</TableCell>
                    <TableCell align="center">
                      {c.partnerId && c.presetType !== 'video' && (
                        <Tooltip title="View conversation">
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleViewConversation(c)}
                          >
                            <ChatIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                      {c.presetType === 'video' && c.connectionId && (
                        <Tooltip title="Open video booking">
                          <IconButton
                            size="small"
                            color="primary"
                            component={Link}
                            to={`/video-bookings/${c.connectionId}`}
                            state={{ from: { label: user?.username || `User #${id}`, path: `/user/${id}` } }}
                          >
                            <VideocamIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>

      <Card sx={{ borderRadius: 2 }}>
        <CardHeader
          avatar={<Avatar sx={{ bgcolor: 'success.main' }}><MonetizationOnIcon /></Avatar>}
          title="Daily Claims"
        subheader={
          claimInfo.total
            ? `Total: ${claimInfo.total} · Current streak: ${claimInfo.currentStreak} · Longest: ${claimInfo.longestStreak}`
            : 'No claims'
        }
        action={
          <IconButton aria-label="expand" onClick={() => setClaimsOpen(o => !o)} disabled={!claimInfo.total}>
            <ExpandMoreIcon />
          </IconButton>
        }
      />
      <Divider />
      <CardContent>
        <Collapse in={claimsOpen} timeout="auto" unmountOnExit>
          {claimInfo.total ? (
            <List dense sx={{ maxHeight: 300, overflow: 'auto' }}>
              {claimInfo.claims.map((r, i) => (
                <ListItem key={i}>
                  <ListItemIcon sx={{ minWidth: '40px' }}>
                    <MonetizationOnIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={dayjs(r.claimDateTime || r.claimDate).format('MMM D, YYYY')} />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body2" color="text.secondary">No claim dates to show.</Typography>
          )}
        </Collapse>
      </CardContent>
    </Card>

      {/* Ratings & Reviews */}
      <Card elevation={3} sx={{ borderRadius: 2 }}>
        <CardHeader
          avatar={<Avatar sx={{ bgcolor: 'warning.main' }}><RateReviewIcon /></Avatar>}
          title="Ratings & Reviews"
          subheader={
            user.averageRating != null
              ? `Average: ${Number(user.averageRating).toFixed(1)} · ${user.totalRatingsReceived || 0} total`
              : 'No ratings yet'
          }
          action={
            <IconButton aria-label="expand ratings" onClick={() => setRatingsOpen(o => !o)} disabled={!ratings.length}>
              <ExpandMoreIcon />
            </IconButton>
          }
        />
        <Divider />
        <CardContent>
          {user.averageRating != null && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <Rating value={Number(user.averageRating)} precision={0.1} readOnly />
              <Typography variant="body2" color="text.secondary">
                {Number(user.averageRating).toFixed(1)} / 5
              </Typography>
            </Box>
          )}
          <Collapse in={ratingsOpen} timeout="auto" unmountOnExit>
            {ratingsLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}><CircularProgress size={24} /></Box>
            ) : !ratings.length ? (
              <Typography variant="body2" color="text.secondary">No individual ratings.</Typography>
            ) : (
              <List dense sx={{ maxHeight: 400, overflow: 'auto' }}>
                {ratings.map((r, i) => (
                  <ListItem key={r.id || i} sx={{ alignItems: 'flex-start', pb: 1 }}>
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Link
                            to={`/user/${r.raterId}`}
                            state={{ from: { label: user.username || `User #${user.id}`, path: `/user/${user.id}` } }}
                            style={{ textDecoration: 'none', color: theme.palette.primary.main, fontWeight: 600 }}
                          >
                            {r.raterUsername || `User #${r.raterId}`}
                          </Link>
                          <Rating value={Number(r.ratingValue)} size="small" readOnly />
                          {r.submissionType && <Chip size="small" variant="outlined" label={r.submissionType} />}
                        </Box>
                      }
                      secondary={
                        <>
                          {r.comments && <Typography variant="body2" sx={{ mt: 0.5 }}>{r.comments}</Typography>}
                          <Typography variant="caption" color="text.secondary">{formatDateTime(r.createdAt)}</Typography>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </Collapse>
        </CardContent>
      </Card>

      {/* Auction History (creator only) */}
      {isCreator && (
        <Card elevation={3} sx={{ borderRadius: 2 }}>
          <CardHeader
            avatar={<Avatar sx={{ bgcolor: theme.palette.secondary.main }}><GavelIcon /></Avatar>}
            title="Auction History"
            subheader={`${auctions.length} auction${auctions.length !== 1 ? 's' : ''}`}
          />
          <Divider />
          <CardContent>
            {auctionsLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}><CircularProgress /></Box>
            ) : !auctions.length ? (
              <Typography variant="body2" color="text.secondary">No auctions found.</Typography>
            ) : (
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold' }}>Period</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">Starting Bid</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">IC Price</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">Final Bid</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">Bids</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Winner</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Preset</TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {auctions.map((a) => (
                      <TableRow key={a.id} sx={{ '&:nth-of-type(odd)': { backgroundColor: 'action.hover' } }}>
                        <TableCell>
                          {a.periodStart ? `${dayjs(a.periodStart).format('MMM D')} – ${dayjs(a.periodEnd).format('MMM D, YYYY')}` : '—'}
                        </TableCell>
                        <TableCell align="right">{a.startingBid != null ? Number(a.startingBid).toLocaleString() : '—'}</TableCell>
                        <TableCell align="right">{a.instantConnectPrice != null ? Number(a.instantConnectPrice).toLocaleString() : '—'}</TableCell>
                        <TableCell align="right">{a.finalBid != null ? Number(a.finalBid).toLocaleString() : '—'}</TableCell>
                        <TableCell align="right">{a.bidCount ?? 0}</TableCell>
                        <TableCell>
                          {a.winnerUserId ? (
                            <Link
                              to={`/user/${a.winnerUserId}`}
                              state={{ from: { label: user.username || `User #${user.id}`, path: `/user/${user.id}` } }}
                              style={{ textDecoration: 'none', color: theme.palette.primary.main, fontWeight: 600 }}
                            >
                              {a.winnerUsername || `User #${a.winnerUserId}`}
                            </Link>
                          ) : '—'}
                        </TableCell>
                        <TableCell>{[a.icPresetLabel, a.btcPresetLabel].filter(Boolean).join(' / ') || '—'}</TableCell>
                        <TableCell>
                          <Chip
                            size="small"
                            label={a.status || 'unknown'}
                            color={a.status === 'completed' || a.status === 'active' ? 'success' : 'default'}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </CardContent>
        </Card>
      )}

      <Card elevation={3} sx={{ borderRadius: 2, display: 'flex', flexDirection: 'column', flex: 1 }}>
        <CardHeader
          avatar={<Avatar sx={{ bgcolor: 'secondary.main' }}><SmsIcon /></Avatar>}
          title="Messages (SMS)"
        subheader={
          msgMeta
            ? (msgMeta.isGloballyUnsubscribed ? 'Currently OPTED OUT' : 'Active')
            : ''
        }
        action={
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', pr: 1 }}>
            {msgMeta && (
              <>
                <Chip
                  size="small"
                  color={msgMeta.isGloballyUnsubscribed ? 'error' : 'success'}
                  icon={msgMeta.isGloballyUnsubscribed ? <StopCircleIcon /> : <CheckCircleIcon />}
                  label={msgMeta.isGloballyUnsubscribed ? 'SMS Opted Out' : 'SMS Active'}
                />
                <Chip
                  size="small"
                  variant="outlined"
                  label={`Last STOP: ${msgMeta.lastStopAt ? new Date(msgMeta.lastStopAt).toLocaleString() : '—'}`}
                />
                <Chip
                  size="small"
                  variant="outlined"
                  label={`Last START: ${msgMeta.lastStartAt ? new Date(msgMeta.lastStartAt).toLocaleString() : '—'}`}
                />
                {/* NEW: SMS notifications preference (separate from STOP compliance) */}
                {typeof msgMeta.smsNotification !== 'undefined' && (
                  <Chip
                    size="small"
                    color={Number(msgMeta.smsNotification) === 1 ? 'primary' : 'warning'}
                    variant={Number(msgMeta.smsNotification) === 1 ? 'filled' : 'outlined'}
                    icon={Number(msgMeta.smsNotification) === 1 ? <NotificationsActiveIcon /> : <NotificationsOffIcon />}
                    label={Number(msgMeta.smsNotification) === 1 ? 'SMS Notifications On' : 'SMS Notifications Off'}
                  />
                )}
              </>
            )}
          </Box>
        }
      />
      <Divider />
      <CardContent sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
        {msgLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress />
          </Box>
        ) : messages.length === 0 ? (
          <Typography variant="body2" color="text.secondary">No messages in the selected window.</Typography>
        ) : (
          <Box 
            ref={messagesContainerRef}
            onScroll={handleScroll}
            sx={{ display: 'flex', flexDirection: 'column', gap: 1.25, flex: 1, overflow: 'auto', mb: 2, maxHeight: 500 }}
          >
            {messages.map((m, idx) => {
              const isOut = m.dir === 'out';
              return (
                <Box key={idx} sx={{ display: 'flex', justifyContent: isOut ? 'flex-end' : 'flex-start' }}>
                  <Box
                    sx={{
                      maxWidth: '78%',
                      px: 1.25, py: 1,
                      borderRadius: 2,
                      bgcolor: isOut ? 'primary.main' : 'action.hover',
                      color: isOut ? 'primary.contrastText' : 'text.primary',
                      boxShadow: 1
                    }}
                  >
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                      {m.body || (isOut ? '(no body)' : '(empty)')}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, mt: .5, opacity: .8 }}>
                      <Typography variant="caption">{new Date(m.ts).toLocaleString()}</Typography>
                      {isOut && m.status && (
                        <Typography variant="caption">· {m.status}</Typography>
                      )}
                      {m.messageType && (
                        <Typography variant="caption">· {m.messageType}</Typography>
                      )}
                      {m.campaign && (
                        <Typography variant="caption">· {m.campaign}</Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}

        {msgMeta?.isGloballyUnsubscribed ? (
          <Alert severity="warning" sx={{ mt: 2 }}>
            This user has opted out via STOP. You cannot send SMS.
          </Alert>
        ) : null}

        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
          <TextField
            fullWidth
            size="small"
            label="Send a message"
            placeholder="Type your SMS…"
            value={newMsg}
            onChange={(e) => setNewMsg(e.target.value)}
            disabled={sending || msgLoading || msgMeta?.isGloballyUnsubscribed}
            inputProps={{ maxLength: 1000 }}
            helperText={`${newMsg.length}/1000`}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={msgMeta?.isGloballyUnsubscribed ? 'User opted out (STOP)' : 'Send'}>
                    <span>
                      <IconButton
                        color="primary"
                        onClick={async () => {
                          const body = (newMsg || '').trim();
                          if (!body || sending || msgMeta?.isGloballyUnsubscribed) return;
                          setSending(true);
                          try {
                            const r = await sendSmsToUser(id, body);
                            setToast({ sev: r?.success ? 'success' : 'warning', msg: r?.message || (r?.success ? 'Queued' : 'Not sent') });
                            setNewMsg('');
                            // quick optimistic bubble (optional)
                            setMessages(prev => ([...prev, { dir: 'out', ts: new Date().toISOString(), body, status: 'queued' }]));
                            // real refresh
                            setTimeout(() => { reloadMessages(); }, 600);
                          } catch (e) {
                            setToast({ sev: 'error', msg: e?.response?.data?.message || 'Failed to send' });
                          } finally {
                            setSending(false);
                          }
                        }}
                        disabled={sending || !newMsg.trim() || msgMeta?.isGloballyUnsubscribed}
                        aria-label="Send SMS"
                      >
                        {sending ? <CircularProgress size={18} /> : <SendIcon />}
                      </IconButton>
                    </span>
                  </Tooltip>
                </InputAdornment>
              )
            }}
          />
        </Box>
      </CardContent>
    </Card>
    </Box>
  </Grid>

  <Grid item xs={12} md={6}>
    <Card elevation={3} sx={{ borderRadius: 2 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'success.main' }}>
            <StarIcon />
          </Avatar>
        }
        title="Referral Earnings"
        titleTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
      />
      <Divider />
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
          <Typography variant="body1">Direct completed:</Typography>
          <Typography variant="body1" fontWeight="bold">{tokenStats.directCount}</Typography>
        </Box>
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
          <Typography variant="body1">2-level completed:</Typography>
          <Typography variant="body1" fontWeight="bold">{tokenStats.grandCount}</Typography>
        </Box>
        
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          mb: 2, 
          mt: 3,
          p: 2,
          bgcolor: alpha('#4caf50', 0.08),
          borderRadius: 1
        }}>
          <Typography variant="body1" fontWeight="medium">Total tokens:</Typography>
          <Typography variant="h6" fontWeight="bold" color="success.main">{tokenStats.tokens}</Typography>
        </Box>
        
        <Button 
          variant="contained" 
          component={Link} 
          to={`/referral-tree/${id}`} 
          fullWidth
          size="large"
          sx={{ 
            mt: 2, 
            bgcolor: 'success.main', 
            '&:hover': { bgcolor: 'success.dark' },
            borderRadius: 2,
            boxShadow: 2
          }}
        >
          View Referral Tree
        </Button>
      </CardContent>
    </Card>
  </Grid>

  <Grid item xs={12} md={6}>
    <Card elevation={3} sx={{ borderRadius: 2 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'info.main' }}>
            <InfoIcon />
          </Avatar>
        }
        title="Direct Referrals"
        titleTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
      />
      <Divider />
      <CardContent>
        {directReferrals.length > 0 ? (
          <List>
            {directReferrals.map(r => (
              <ListItem 
                key={r.id}
                secondaryAction={
                  r.completed ? 
                    <CheckCircleIcon color="success" /> : 
                    <CheckCircleIcon color="action" />
                }
                sx={{ 
                  borderRadius: 2, 
                  mb: 1,
                  p: 1.5,
                  '&:hover': { bgcolor: alpha('#f5f5f5', 0.8) },
                  border: '1px solid',
                  borderColor: 'divider'
                }}
              >
                <ListItemText 
                  primary={
                    <Link 
                      to={`/user/${r.id}`}
                      state={{ from: { label: user.username || `User #${user.id}`, path: `/user/${user.id}` } }}
                      style={{ textDecoration: 'none', color: 'inherit', fontWeight: 'bold' }}
                    >
                      {r.username || r.id}
                    </Link>
                  } 
                  secondary={r.completed ? "Completed" : "Not completed"}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <EmptyState title="No direct referrals" message="This user has not referred anyone yet." />
        )}
      </CardContent>
    </Card>
  </Grid>

  <Grid item xs={12} md={6}>
    <Card elevation={3} sx={{ borderRadius: 2 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'primary.main' }}>
            <HistoryIcon />
          </Avatar>
        }
        title="Login History"
        titleTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
      />
      <Divider />
      <CardContent>
        {loginHistory && loginHistory.length > 0 ? (
          <List dense sx={{ maxHeight: 300, overflow: 'auto' }}>
            {loginHistory.map((login, index) => (
              <ListItem key={index}>
                <ListItemIcon sx={{minWidth: '40px'}}>
                  <LoginIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={formatDateTime(login.login_at)} />
              </ListItem>
            ))}
          </List>
        ) : (
          <EmptyState title="No login history" message="This user has no recorded sessions." />
        )}
      </CardContent>
    </Card>
  </Grid>

  <Grid item xs={12} md={6}>
    <Card elevation={3} sx={{ borderRadius: 2 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'secondary.main' }}>
            <CreditCardIcon />
          </Avatar>
        }
        title="Transaction History"
        titleTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
      />
      <Divider />
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Date/Time</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="right">Amount</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="right">Balance After</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.length > 0 ? (
              transactions.map((tx, index) => (
                <TableRow key={index}>
                  <TableCell>{formatDateTime(tx.created_at)}</TableCell>
                  <TableCell>{tx.transaction_type}</TableCell>
                  <TableCell align="right">{tx.amount}</TableCell>
                  <TableCell align="right">{tx.balance_after}</TableCell>
                  <TableCell>
                    {tx.transaction_type === 'bid' && (tx.bid_on_username || tx.bid_target_username) ? (
                      <>
                        Bid on <Link
                          to={`/user/${tx.bid_on_user_id || tx.bid_target_id}`}
                          state={{ from: { label: user.username || `User #${user.id}`, path: `/user/${user.id}` } }}
                        >{tx.bid_on_username || tx.bid_target_username}</Link>
                      </>
                    ) : (
                      <>
                        {tx.details || '-'}
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                  <Typography color="text.secondary">No transaction history found.</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  </Grid>

</Grid>

{/* Delete confirmation dialog */}
<Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
  <DialogTitle>Delete this user?</DialogTitle>
  <DialogContent>
    <Typography variant="body2" sx={{ mb: 1.5 }}>
      This will permanently remove the user and related data handled by the backend callback.
    </Typography>
    <Typography variant="body2" sx={{ mb: 1 }}>
      Type <b>delete</b> to confirm:
    </Typography>
    <TextField
      autoFocus
      fullWidth
      size="small"
      value={deleteTyped}
      onChange={(e) => setDeleteTyped(e.target.value)}
      placeholder="delete"
    />
    {deleteResult && (
      <Alert sx={{ mt: 2 }} severity={deleteResult.success ? 'success' : 'error'}>
        {deleteResult.message || (deleteResult.success ? 'Deleted.' : 'Delete failed.')}
      </Alert>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setDeleteOpen(false)} disabled={deleteBusy}>Cancel</Button>
    <Button
      color="error"
      variant="contained"
      disabled={deleteBusy || deleteTyped.trim().toLowerCase() !== 'delete'}
      onClick={async () => {
        try {
          setDeleteBusy(true);
          const res = await adminDeleteUser(id);
          setDeleteResult(res);
          if (res?.success) {
            setTimeout(() => {
              setDeleteOpen(false);
              navigate('/user-report', { replace: true });
            }, 900);
          }
        } catch (e) {
          setDeleteResult({ success: false, message: e?.response?.data?.message || 'Delete failed' });
        } finally {
          setDeleteBusy(false);
        }
      }}
    >
      {deleteBusy ? 'Deleting...' : 'Confirm delete'}
    </Button>
  </DialogActions>
</Dialog>

<Snackbar
  open={!!toast}
  autoHideDuration={4000}
  onClose={() => setToast(null)}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
>
  {toast ? <MuiAlert elevation={6} variant="filled" severity={toast.sev} onClose={() => setToast(null)}>{toast.msg}</MuiAlert> : null}
</Snackbar>

{/* Verification Video Modal */}
<Dialog
  open={videoModalOpen}
  onClose={() => setVideoModalOpen(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <VideoLibraryIcon color="primary" />
      <Typography variant="h6">Verification Video</Typography>
    </Box>
  </DialogTitle>
  <DialogContent>
    {videoUrl ? (
      <Box
        component="video"
        src={videoUrl}
        controls
        autoPlay
        sx={{
          width: '100%',
          maxHeight: '70vh',
          borderRadius: 2,
          bgcolor: '#000'
        }}
      />
    ) : (
      <Box sx={{ py: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">No verification video available</Typography>
      </Box>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setVideoModalOpen(false)} variant="outlined">
      Close
    </Button>
  </DialogActions>
</Dialog>

{/* Profile Image Lightbox Modal */}
<Dialog
  open={selectedImageIndex !== null}
  onClose={() => setSelectedImageIndex(null)}
  maxWidth="lg"
  fullWidth
  PaperProps={{
    sx: {
      bgcolor: 'rgba(0, 0, 0, 0.9)',
      boxShadow: 24,
      maxHeight: '95vh'
    }
  }}
>
  <DialogContent 
    sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      p: 2,
      position: 'relative'
    }}
  >
    {selectedImageIndex !== null && profileImageUrls[selectedImageIndex] && (
      <Box
        component="img"
        src={profileImageUrls[selectedImageIndex]}
        alt={`${user.username || 'User'} profile ${selectedImageIndex + 1}`}
        sx={{
          maxWidth: '100%',
          maxHeight: '85vh',
          objectFit: 'contain',
          borderRadius: 2
        }}
      />
    )}
  </DialogContent>
  <DialogActions sx={{ bgcolor: 'rgba(0, 0, 0, 0.9)', justifyContent: 'space-between', px: 2 }}>
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Button 
        onClick={() => setSelectedImageIndex(prev => prev > 0 ? prev - 1 : profileImageUrls.length - 1)}
        variant="outlined"
        disabled={profileImageUrls.length <= 1}
        sx={{ color: 'white', borderColor: 'white', '&:hover': { borderColor: 'white', bgcolor: 'rgba(255,255,255,0.1)' } }}
      >
        Previous
      </Button>
      <Button 
        onClick={() => setSelectedImageIndex(prev => prev < profileImageUrls.length - 1 ? prev + 1 : 0)}
        variant="outlined"
        disabled={profileImageUrls.length <= 1}
        sx={{ color: 'white', borderColor: 'white', '&:hover': { borderColor: 'white', bgcolor: 'rgba(255,255,255,0.1)' } }}
      >
        Next
      </Button>
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="caption" sx={{ color: 'white', mr: 1 }}>
        {selectedImageIndex !== null ? `${selectedImageIndex + 1} / ${profileImageUrls.length}` : ''}
      </Typography>
      {selectedImageIndex !== null && profileImageMeta[selectedImageIndex]?.id && (
        <Button
          onClick={() => {
            setDeleteImageId(profileImageMeta[selectedImageIndex].id);
            setDeleteImageOpen(true);
          }}
          variant="contained"
          color="error"
          size="small"
          startIcon={<DeleteIcon />}
        >
          Delete
        </Button>
      )}
      <Button
        onClick={() => setSelectedImageIndex(null)}
        variant="contained"
        sx={{ bgcolor: 'white', color: 'black', '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' } }}
      >
        Close
      </Button>
    </Box>
  </DialogActions>
</Dialog>

{/* Conversation Modal */}
{chatOpen && chatPair && (
  <ConversationModal
    open={chatOpen}
    onClose={() => { setChatOpen(false); setChatPair(null); }}
    userId={chatPair.userId}
    partnerId={chatPair.partnerId}
    userRole={chatPair.userRole}
    partnerRole={chatPair.partnerRole}
    title={`Conversation — ${chatPair.userName} ↔ ${chatPair.partnerName}`}
  />
)}

{/* Deleted Images Lightbox Modal */}
<Dialog
  open={selectedDeletedImageIndex !== null}
  onClose={() => setSelectedDeletedImageIndex(null)}
  maxWidth="lg"
  fullWidth
  PaperProps={{
    sx: {
      bgcolor: 'rgba(0, 0, 0, 0.9)',
      boxShadow: 24,
      maxHeight: '95vh'
    }
  }}
>
  <DialogContent 
    sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      p: 2,
      position: 'relative'
    }}
  >
    {selectedDeletedImageIndex !== null && deletedImageUrls[selectedDeletedImageIndex] && (
      <Box
        component="img"
        src={deletedImageUrls[selectedDeletedImageIndex]}
        alt={`${user.username || 'User'} deleted image ${selectedDeletedImageIndex + 1}`}
        sx={{
          maxWidth: '100%',
          maxHeight: '85vh',
          objectFit: 'contain',
          borderRadius: 2
        }}
      />
    )}
  </DialogContent>
  <DialogActions sx={{ bgcolor: 'rgba(0, 0, 0, 0.9)', justifyContent: 'space-between', px: 2 }}>
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Button 
        onClick={() => setSelectedDeletedImageIndex(prev => prev > 0 ? prev - 1 : deletedImageUrls.length - 1)}
        variant="outlined"
        disabled={deletedImageUrls.length <= 1}
        sx={{ color: 'white', borderColor: 'white', '&:hover': { borderColor: 'white', bgcolor: 'rgba(255,255,255,0.1)' } }}
      >
        Previous
      </Button>
      <Button 
        onClick={() => setSelectedDeletedImageIndex(prev => prev < deletedImageUrls.length - 1 ? prev + 1 : 0)}
        variant="outlined"
        disabled={deletedImageUrls.length <= 1}
        sx={{ color: 'white', borderColor: 'white', '&:hover': { borderColor: 'white', bgcolor: 'rgba(255,255,255,0.1)' } }}
      >
        Next
      </Button>
    </Box>
    <Box>
      <Typography variant="caption" sx={{ color: 'white', mr: 2 }}>
        {selectedDeletedImageIndex !== null ? `${selectedDeletedImageIndex + 1} / ${deletedImageUrls.length}` : ''}
      </Typography>
      <Button 
        onClick={() => setSelectedDeletedImageIndex(null)} 
        variant="contained"
        sx={{ bgcolor: 'white', color: 'black', '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' } }}
      >
        Close
      </Button>
    </Box>
  </DialogActions>
</Dialog>

{/* Delete Image Confirmation Dialog */}
<Dialog open={deleteImageOpen} onClose={() => { setDeleteImageOpen(false); setDeleteImageId(null); setDeleteImagePermanent(false); }}>
  <DialogTitle>Delete Image</DialogTitle>
  <DialogContent>
    <Typography sx={{ mb: 2 }}>
      Are you sure you want to delete this image?
    </Typography>
    <FormControlLabel
      control={
        <Checkbox
          checked={deleteImagePermanent}
          onChange={(e) => setDeleteImagePermanent(e.target.checked)}
          color="error"
        />
      }
      label="Permanently delete (cannot be recovered)"
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => { setDeleteImageOpen(false); setDeleteImageId(null); setDeleteImagePermanent(false); }} disabled={deleteImageBusy}>
      Cancel
    </Button>
    <Button
      onClick={handleDeleteImage}
      variant="contained"
      color="error"
      disabled={deleteImageBusy}
    >
      {deleteImageBusy ? 'Deleting...' : deleteImagePermanent ? 'Permanently Delete' : 'Delete'}
    </Button>
  </DialogActions>
</Dialog>

{/* Remove Creator from Browse Confirmation Dialog */}
<Dialog open={removeCreatorOpen} onClose={() => setRemoveCreatorOpen(false)}>
  <DialogTitle>Remove Creator from Browse</DialogTitle>
  <DialogContent>
    <Typography>
      Are you sure you want to remove <strong>{user?.username}</strong> from browse?
      This will unapprove the creator and clean up their active auctions (with refunds if applicable).
    </Typography>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setRemoveCreatorOpen(false)} disabled={removeCreatorBusy}>
      Cancel
    </Button>
    <Button
      onClick={handleRemoveCreator}
      variant="contained"
      color="warning"
      disabled={removeCreatorBusy}
    >
      {removeCreatorBusy ? 'Removing...' : 'Remove from Browse'}
    </Button>
  </DialogActions>
</Dialog>

</>
);
}